export default __webpack_public_path__ + "static/media/featureko.ffbcd7ae.svg";